import "../../components/button/StyledButton.css"
import AddEcomForm from "components/addEcomForm/AddEcomForm";
import { useGetEcomLatestQuery } from "api/api";
import * as z from "zod";
import { createEcomFieldValidation } from "./helpers";

const AddEcomSteelPage = () => {
  const { data: latestEcomData = [] } = useGetEcomLatestQuery();
  const filteredEcomData = latestEcomData['ECOMData'].filter(data => data.material_category === 'Steel');
  const materialMapping = filteredEcomData.reduce((accumulator, material) => {
    accumulator[material.material_type] = material.a1_a3_carbon_factor;
    return accumulator;
  }, {});

  const inputLabels = [
    { name: "fabricated_HR_structural", label: "Fabricated HR Structural Sections", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Rolled Steel Shapes'], component: "FormTextField" },
    { name: "fabricated_structural_plate", label: "Fabricated Structural Plate", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Plate Steel Fabrications'], component: "FormTextField" },
    { name: "fabricated_hollow_structural", label: "Fabricated Hollow Struc. Sections", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Tube Steel (HSS)'], component: "FormTextField" },
    { name: "open_web_steel_joists", label: "Open Web Steel Joists", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Open Web Steel Joists'], component: "FormTextField" },
    { name: "steel_deck", label: "Steel Deck", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Steel Deck'], component: "FormTextField" },
    { name: "cold_form_metal_framing", label: "Cold Formed Metal Framing", unit: "kgCO2e/ton", value: null, type: 'number', latestValue: materialMapping['Cold Formed Metal Framing'], component: "FormTextField" },
  ];

  const inputNames = inputLabels.map((input) => input.name)

  const schema = z.object(
    Object.fromEntries(
      inputNames.map(key => [key, createEcomFieldValidation(key)])
    )
  );

  return (
    <AddEcomForm
      title="Steel"
      inputLabels={inputLabels}
      stage={5}
      validationSchema={schema}
    />
  );
}

export default AddEcomSteelPage;